import script from "./YaklasanRandevular.vue?vue&type=script&setup=true&lang=js"
export * from "./YaklasanRandevular.vue?vue&type=script&setup=true&lang=js"

import "./YaklasanRandevular.vue?vue&type=style&index=0&id=63c450a9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63c450a9"]])

export default __exports__